module.exports = __webpack_public_path__ + "static/media/state-15.a499d918.jpg";